import { useColor } from './useColor'

export const usePrimaryGradient = (): string => {
  const startColor = useColor({ palette: 'primary', nuance: 4 })
  const finishColor = useColor({ palette: 'primary', nuance: 5 })

  return `linear(180deg, ${startColor} 0%, ${finishColor} 100%)`
}
